import { PawPrint } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { useSiteEmails, useInfoPage, pick } from "../lib/siteContent";
import { InfoPageSkeleton } from "../components/InfoPageSkeleton";

export default function About() {
  const emails = useSiteEmails();
  const { lang } = useLanguage();
  const page = useInfoPage("about");
  if (!page) return <InfoPageSkeleton testid="about-page" />;
  const f = (k) => pick(page.fields[k], lang);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="about-page">
      <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-[#F5551E] bg-[#FFF4F0] rounded-full px-3 py-1"><PawPrint size={13} /> {f("badge")}</span>
      <h1 className="font-display font-extrabold text-4xl text-[#12234A] mt-4" data-testid="about-title">{f("title")}</h1>
      <p className="text-base text-slate-600 mt-5">{f("intro")}</p>

      <div className="mt-8 space-y-7">
        {page.sections.map((s, i) => (
          <section key={`${i}-${s.h.en}`} data-testid={`about-section-${i}`}>
            <h2 className="font-display font-bold text-lg text-[#12234A]">{pick(s.h, lang)}</h2>
            <p className="text-sm text-slate-600 mt-2 leading-relaxed whitespace-pre-line">{pick(s.p, lang)}</p>
          </section>
        ))}
      </div>

      {f("contact") && (
        <div className="mt-10 rounded-2xl bg-[#F8FAFC] border border-slate-100 p-5">
          <p className="text-sm text-slate-600">{f("contact")} <a href={`mailto:${emails.contact}`} className="text-[#F5551E] font-semibold hover:underline" data-testid="site-contact-email">{emails.contact}</a>.</p>
        </div>
      )}
    </div>
  );
}
